module.exports = __webpack_public_path__ + "static/media/DownArrow.0a5bd638.png";